import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Index from "./views/Index.vue";
import Products from "./views/Products.vue";
import Experience from "./views/Experience.vue";
import Brand from "./views/Brand.vue";
import About from "./views/About.vue";
import news from "./views/News.vue";
import AI from "./views/AI.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Index,
      children: [
        {
          path: "/",
          name: "home",
          component: Home
        },

        {
          path: "/products",
          name: "products",
          component: Products
        },
        {
          path: "/experience",
          name: "Experience",
          component: Experience
        },
        {
          path: "/brand",
          name: "Brand",
          component: Brand
        },
		{
		  path: "/AI",
		  name: "AI",
		  component: AI
		},
        {
          path: "/news/:id",
          name: "news",
          component: news
        },
        {
          path: "home",
          redirect: "/"
        },
        {
          path: "/about",
          name: "about",
          component: About
        }
      ]
    }
  ],
  // 滚动控制 to, from, savedPosition
  scrollBehavior(to) {
    if (to.path === "/Products" && to.query.id) {
      return { x: 0, y: 300 };
    }
    return { x: 0, y: 0 };
  }
});
